/* eslint-disable prefer-template */
/* eslint-disable react/no-danger */
/* eslint-disable no-constant-condition */
/* eslint-disable no-unused-vars */
/* eslint-disable arrow-body-style */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */


import React, { useState, useEffect, useCallback, useLayoutEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  Box, Typography, Button, IconButton, Table, TableHead, TableBody, TableRow, TableCell, Tabs,
  Tab, Grid, Paper, Card, Accordion, AccordionSummary, AccordionDetails, Divider, useTheme, LinearProgress,
  ButtonGroup,
} from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import adminServices from '../../../services/adminServices';

// import './style.css'


const SATReportReplica = () => {
  const location = useLocation();
  console.log(location.state?.data,"333333333333");
  
  const [activeTab, setActiveTab] = useState('report');
  const [activeTabs, setActiveTabs] = useState(location.state?.data?.assessment_type === 'Maths Chapter Test' ? "m1" : "rw1");
  const [allQuestions, setAllQuestions] = useState([]);
  const [analysis, setAnalysis] = useState([]);
  const [analysisTestScore, setAnalysisTestScore] = useState([]);
  const navigate = useNavigate();

  const userid = useSelector((state) => state?.userInfo && state?.userInfo?.id);
  const [name, setName] = useState(0);
  const [module, setModule] = useState(location.state?.data?.assessment_type === 'Maths Chapter Test' ? "Maths" : "English");
  const { userInfo } = useSelector((state) => state);

  useEffect(() => {
    getAnalysisTestScore()
  }, [])

   const useMobileLandscape = () => {
      const [isMobileLandscape, setIsMobileLandscape] = useState(
        window.innerWidth > 600 && window.innerHeight <= 455
      );
        
      useEffect(() => {
        const handleResize = () => {
          setIsMobileLandscape(
            window.innerWidth > 600 && window.innerHeight <= 455
          );
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
      }, []);
      return isMobileLandscape;
    }
  
    const mobileLandscape = useMobileLandscape();


  const getAnalysisTestScore = async () => {

    const result = await adminServices.getChapterLevelAnalysis(location.state?.data?.data?.id, userid, location?.state.fromindex,'Chapter')
    if (result.ok) {
      setAnalysisTestScore(result.data)
      setAllQuestions(result.data.Questions)
    }
  }

  const timesNormalized = analysisTestScore?.Questions?.map(q =>
    q.timeTaken > 1000000
      ? q.timeTaken / 1000000000  
      : q.timeTaken             
  );
  const totalTime = timesNormalized?.reduce((acc, time) => acc + time, 0);
  const avgTime = totalTime / analysisTestScore?.Questions?.length;


  const Header = () => {
    const theme = useTheme();
    return (
      <Box
        sx={{
          width: '100%',
          color: '#fff',
          py: { xs: 4, md: 6 },
          px: { xs: 2, md: 6 },
          borderRadius: 2,
          mt: '100px',
          mb: { xs: 3, md: 5 },
          position: 'relative',
          overflow: 'hidden',
          backgroundColor: `linear-gradient(rgba(31, 78, 216, 0.85), rgba(59, 130, 246, 0.85)) `,
          backgroundSize: 'cover',
          backgroundPosition: 'center 74%',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <Box sx={{}}>
          <Box sx={{ backdropFilter: 'brightness(0.6)', backgroundColor: `linear-gradient(rgba(31, 78, 216, 0.85), rgba(59, 130, 246, 0.85)) ` }}>
            <Grid container alignItems="center" sx={{
              minHeight: '250px',
              backgroundImage: `linear-gradient(rgba(31, 78, 216, 0.60), rgba(59, 130, 246, 0.60)),
  url(https://plus.unsplash.com/premium_photo-1742859699527-2dbda42bfde2?q=80&w=2011&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D)`,
              backgroundSize: 'cover',
              backgroundPosition: 'center 74%',
            }} spacing={2}>
              <Grid item xs={12} md={12} sx={{ padding: '20px' }}>
                <Typography textAlign={'center'} variant="h4" sx={{ fontWeight: 700 }}>
                  Upgrade and experience the most realistic SAT prep Platform
                </Typography>
                <Typography textAlign={'center'} variant="body2" sx={{ mt: 1, opacity: 0.95 }}>
                  Unlock Your Full SAT Potential. Upgrade now to access our complete SAT prep program,
                  featuring adaptive tests, expert-developed materials, and personalized insights.
                </Typography>
                <Box justifyContent={'center'} sx={{ mt: 2, display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                  <Button variant="outlined" sx={{
                    borderColor: 'rgba(255,255,255,0.7)', color: '#fff', borderRadius: '4px', width: { sm: 'auto', md: '250px' }, '&:hover': { borderColor: '#0483d2', color: '#fff', backgroundColor: '#0483d2' }
                  }}>Try Free 7 day trial</Button>

                  <Button variant="contained" sx={{ bgcolor: '#fff', color: '#1f4ed8', fontWeight: 700, borderRadius: '4px', width: { sm: 'auto', md: '250px' }, '&:hover': { borderColor: '#0483d2', color: '#fff', backgroundColor: '#0483d2' } }}>Upgrade Now</Button>
                </Box>
              </Grid>

            </Grid>
          </Box>
        </Box>
      </Box>
    );
  };


  const handleNavigation = () => {
        const comingfrom = "Chapter"
        if (userInfo?.role === 'AUTH_USER') {
            navigate('/app/course', { state: comingfrom });
        }
        else {
            navigate('/auth/subscribe', { state: comingfrom });
        }
    }

  const handleNavigateOverview = () => {
    if (userInfo?.role === 'AUTH_USER') {
      navigate('/app/ChapterOverView', { state: location.state?.data?.data?.assessment_type === 'English Chapter Test' ? 'English':'Maths' });
    } else {
      navigate('/auth/ChapterOverView', { state: location.state?.data?.data?.assessment_type ===  'English Chapter Test' ? 'English':'Maths' });
    }
  };

  const handleNavigateAttempts = () => {

    if (userInfo?.role === 'AUTH_USER') {
      navigate('/auth/ChapterLevelSimulation', {
        state: { 
          chapterid: location.state?.data?.id ,
          type: location.state?.data?.data?.assessment_type ===  'English Chapter Test' ? 'English':'Maths'
        }
      });
    } else {
      navigate('/auth/ChapterLevelSimulation', {
        state: { chapterid: location.state?.data?.id },
        type: location.state?.data?.data?.assessment_type ===  'English Chapter Test' ? 'English':'Maths'
      });
    }
  };

  // eslint-disable-next-line arrow-body-style
  const ScoreCard = () => {
    return (

      <Grid container spacing={2} mt={.5} alignItems="center">

        <Grid item xs={12} md={12} sx={{ height: '-webkit-fill-available' }}>
          <Card sx={{ p: 2, marginRight: '1px', height: 'inherit', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }} id='card'>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 700 ,fontSize:{xs: 14 , sm: 26, md: 18} }}>Performance Overview</Typography>
            <Grid  
            container
              spacing={{ xs: 1.5, sm: 2 }}                              
              sx={{
                alignItems: 'flex-start',
                '& > .statItem': {
                  position: 'relative',
                  borderRight: { md: '1px solid #E5EAF2' },
                  pl: { xs: 1.5, sm: 2 ,md: 0},
                  pt: { xs: 1.5, sm: 2 ,md: 0},
                },
                '& > .statItem:nth-of-type(5n)': {
                  borderRight: { md: 'none' },
                },
              }}
              id="outer-grid">

              <Grid item xs={4} sm={4} md={2.4}>
                <Paper sx={{ p:{ xs: 1, sm:2 , md: 2 }, textAlign: 'left', height: { xs: 'auto', sm: 'auto', md: '100%' } , minHeight: { xs: '110px', sm: '170px', md: '150px' }, display: 'flex', flexDirection: 'column', justifyContent: 'space-around', border: { xs: '1px solid #ccc', sm: '2px solid #ccc', md: '0px solid #fff' } }} elevation={0}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 , minHeight: { xs: 22, sm: 26, md: 24 } }}>
                    <Box sx={{ width: 8, height: 8, backgroundColor: '#4CAF50', borderRadius: '50%' }} />
                    <Typography variant="caption" sx={{ fontWeight:  {xs: 500, sm: 500, md: 700}, fontSize: {xs:'8px', sm:'15px', md:'14px !important'} }}>Correct Answers</Typography>
                  </Box>
                  <Typography variant="h3"
                    sx={{
                      ...(mobileLandscape ? { fontSize: "26px !important", color: "#102A63",  mt: '20px'} : {
                        fontWeight: 800, mt: { xs: 1.3, sm: 3, md: 3 }, lineHeight: 1, color: '#102A63', fontSize: { xs: '18px', sm: '40px', md: '38px !important' }
                      })
                    }} > { analysisTestScore && analysisTestScore?.totalCorrectAnswers}</Typography>
                <Typography variant="caption" sx={{ fontWeight: 500, fontSize: '10px', lineHeight: 1.2, mt: 3, visibility: 'hidden' }} />
              </Paper>
              </Grid>
              {/* <Divider orientation="vertical" sx={{ display: { xs: 'none', sm: 'none' , md: 'block' } }} flexItem /> */}

              <Grid item xs={4} sm={4} md={2.4}>
                <Paper sx={{ p:{ xs: 1, sm:2 , md: 2 }, textAlign: 'left', height: { xs: 'auto', sm: 'auto', md: '100%' } , minHeight: { xs: '110px', sm: '170px', md: '150px' }, display: 'flex', flexDirection: 'column', justifyContent: 'space-around', border: { xs: '1px solid #ccc', sm: '2px solid #ccc', md: '0px solid #fff' } }} elevation={0}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 , minHeight: { xs: 22, sm: 26, md: 24 }}}>
                    <Box sx={{ width: 8, height: 8, backgroundColor: '#FF0000', borderRadius: '50%', flexShrink: 0 }} />
                    <Typography variant="caption" sx={{ fontWeight:  {xs: 500, sm: 500, md: 700}, fontSize: {xs:'8px', sm:'15px', md:'14px !important'} }}>Incorrect Answers</Typography>
                  </Box>
                  <Typography variant="h3"
                    sx={{
                      ...(mobileLandscape ? { fontSize: "26px !important", color: "#102A63",  mt: '20px'} : {
                        fontWeight: 800, mt: { xs: 1.3, sm: 3, md: 3 }, lineHeight: 1, color: '#102A63', fontSize: { xs: '18px', sm: '40px', md: '38px !important' }
                      })
                    }}>{analysisTestScore && analysisTestScore?.totalIncorrectAnswers}</Typography>
                  <Typography variant="caption" sx={{ fontWeight: 500, fontSize: '10px', lineHeight: 1.2, mt: 3, visibility: 'hidden' }} />
                </Paper>
              </Grid>
              {/* <Divider orientation="vertical" sx={{ display: { xs: 'none', sm: 'none' , md: 'block' } }} flexItem /> */}

              <Grid item xs={4} sm={4} md={2.4}>
                <Paper sx={{ p:{ xs: 1, sm:2 , md: 2 }, textAlign: 'left', height: { xs: 'auto', sm: 'auto', md: '100%' } , minHeight: { xs: '110px', sm: '170px', md: '150px' }, display: 'flex', flexDirection: 'column', justifyContent: 'space-around', border: { xs: '1px solid #ccc', sm: '2px solid #ccc', md: '0px solid #fff' } }}  elevation={0}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <Box sx={{ width: 8, height: 8, backgroundColor: '#B3B3B3', borderRadius: '50%'}} />
                    <Typography variant="caption" sx={{ fontWeight:  {xs: 500, sm: 500, md: 700}, fontSize: {xs:'8px', sm:'15px', md:'14px !important'} }}>Questions Attempted</Typography>
                    <Typography variant="caption" sx={{ fontWeight: 700, visibility: 'hidden' }} />
                  </Box>
                  <Typography variant="h3" 
                  sx={{ ...(mobileLandscape ? { fontSize: "26px !important", color: "#102A63", mt: '20px' } : {
                    fontWeight: 800, mt: { xs: 1 ,sm: 3.4 , md: 3}, mb: { xs: 1.2 ,sm: 0 , md: 0}, lineHeight: 1, '@media (min-width:1400px)': { mt: 3 }, color: '#102A63', fontSize: {xs:'18px', sm:'40px', md:'38px !important'}}) }}>{analysisTestScore && analysisTestScore?.attemptedQuestions}</Typography>
                  <Typography variant="caption" sx={{ fontWeight: 500, fontSize: { xs: 6, sm:14 , md: 14 }, lineHeight: 1.2, mt: { xs: 0.5 ,sm: 3 , md: 3} }}>(Out of {analysisTestScore && analysisTestScore?.totalQuestions} Questions )</Typography>
                </Paper>
              </Grid>
              {/* <Divider orientation="vertical" sx={{ display: { xs: 'none', sm: 'none' , md: 'block' } }} flexItem /> */}

              <Grid item xs={4} sm={4} md={2.4}>
                <Paper sx={{ p:{ xs: 1, sm:2 , md: 2 }, textAlign: 'left', height: { xs: 'auto', sm: 'auto', md: '100%' } , minHeight: { xs: '110px', sm: '170px', md: '150px' }, display: 'flex', flexDirection: 'column', justifyContent: 'space-around', border: { xs: '1px solid #ccc', sm: '2px solid #ccc', md: '0px solid #fff' } }} elevation={0}>
                  <Typography variant="caption" sx={{ fontWeight:  {xs: 500, sm: 500, md: 700}, fontSize: {xs:'8px', sm:'15px', md:'14px !important'} }}>Overall Accuracy</Typography>
                  <Typography variant="h3" 
                  sx={{  ...(mobileLandscape ? { fontSize: "26px !important", color: "#102A63", mt: '20px' } : {
                    fontWeight: 800, mt: 3.2, lineHeight: 1, color: '#102A63', fontSize: {xs:'18px', sm:'40px', md:'38px !important'}}) }}>{analysisTestScore && analysisTestScore?.overallAccuracy}%</Typography>
                  <Typography variant="caption" sx={{ fontWeight: 500, fontSize: '10px', lineHeight: 1.2, mt: 3, visibility: 'hidden' }} />
                </Paper>
              </Grid>
              {/* <Divider orientation="vertical" sx={{ display: { xs: 'none', sm: 'none' , md: 'block' } }} flexItem /> */}

              <Grid item xs={4} sm={4} md={2.4}>
                <Paper sx={{ p:{ xs: 1, sm:2 , md: 2 }, textAlign: 'left', height: { xs: 'auto', sm: 'auto', md: '100%' } , minHeight: { xs: '110px', sm: '170px', md: '150px' }, display: 'flex', flexDirection: 'column', justifyContent: 'space-around', border: { xs: '1px solid #ccc', sm: '2px solid #ccc', md: '0px solid #fff' } }} elevation={0}>
                  <Typography variant="caption" sx={{ fontWeight:  {xs: 500, sm: 500, md: 700}, fontSize: {xs:'8px', sm:'15px', md:'14px !important'} }}>Time Spent Per Question</Typography>
                  <Typography variant="h3" 
                  sx={{  ...(mobileLandscape ? { fontSize: "26px !important", color: "#102A63", mt: '20px' } : {
                    fontWeight: 800, mt: 1.8, lineHeight: 1, '@media (min-width:1400px)': { mt: 3 }, color: '#102A63', fontSize: {xs:'18px', sm:'40px', md:'38px !important'} }) }}> {analysisTestScore && avgTime.toFixed(2)}s</Typography>
                  <Typography variant="caption" sx={{ fontWeight: 500, fontSize: '10px', lineHeight: 1.2, mt: 3, visibility: 'hidden' }} />
                </Paper>
              </Grid>
            </Grid>
            <Grid container spacing={1} sx={{ mt: 3 }}>
              <Divider orientation="horizontal" flexItem />
              <Grid item xs={12} sx={{ borderTop:'1px solid #ccc' }} >
                <Typography variant="body2" sx={{ mb: 0.5, mt: 0.5, fontWeight: 500 , fontSize:{ xs: 12, sm: 22, md: 22 }}}>Improvement Tips: </Typography>
                <Typography variant="body2" sx={{ mb: 1, fontWeight: 500  , fontSize:{ xs: 10, sm: 16, md: 16 } }}>Steady effort makes the difference. Continue completing practice tests to move toward your ideal SAT score</Typography>
              </Grid>
            </Grid>
          </Card>
          {/* <Divider orientation="horizontal" flexItem /> */}
        </Grid>
        {/* <Grid item xs={12} md={2.5} pt={2} sx={{ height: '-webkit-fill-available', }}>
          <Box sx={{height: 'inherit', border: '2px solid #9ebbfd', padding: '16px !important', borderRadius: '6px', backgroundColor: '#f0f4ff',
            display: 'flex', flexDirection: 'column', justifyContent: 'space-around'}}>
            <Typography variant='h6' sx={{color: '#1b5ab2'}}>Download Your Test Report PDF for Later</Typography>
             <Typography variant='body2' sx={{color: '#111'}}>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard</Typography>
            <Button variant="contained" startIcon={<GetAppIcon />} sx={{ bgcolor: '#1f4ed8', textTransform: 'none' , borderRadius: '4px'}}>Download</Button>
          </Box>
        </Grid> */}
      </Grid>

    );
  };

  // eslint-disable-next-line arrow-body-style

  // eslint-disable-next-line arrow-body-style

  const QuestionWiseAnalysis = () => {

    const [expanded, setExpanded] = useState(null);

    const handleAccordionChange = (panel) => (event, isExpanded) => {
      setExpanded(isExpanded ? panel : null);
    };

    useLayoutEffect(() => {
      const savedScrollPosition = sessionStorage.getItem('scrollPosition');
      if (savedScrollPosition) {
        window.scrollTo(0, parseInt(savedScrollPosition, 10));
      }
    }, [activeTabs]);


    useEffect(() => {
      const handleScroll = () => {
        sessionStorage.setItem('scrollPosition', window.scrollY);
      };
      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const isPassageVisible = (location.state?.data?.type === "Chapter" && location.state?.data?.assessment_type ===  'English Chapter Test') // English

    return (
      <>
        <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 , fontSize:{xs:'14px', sm:'26px', md:'26px'}}}>
          Question-wise Analysis
        </Typography>

        <Box
          sx={{
            background: '#eaf2fe',       
            textAlign: 'center',
            color: '#225AD6',            
            fontWeight: 600,
            fontSize: { xs: 10, sm: 13, md: 14 },
            borderBottom: '2px solid #225AD6',
            display:'flex',
            justifyContent:'center',
            alignItems:'center',
            padding:{ xs: '8px 10px', sm: '10px 12px', md:'10px 12px'}, 
            width: '100%',
            height:'50px',
            mb: 3,
          }}
        >
          {location.state?.data?.data?.chapter_description} Test
        </Box>

        <Box sx={{ mt: 4 }}>

          {allQuestions && allQuestions?.length > 0 && allQuestions.map((question, index) => (
            <Card
            key={question.questionId}
            sx={{
                borderRadius: 1,
                boxShadow: "none",
                border: "1px solid #e0e0e0",
                mb: 2,
                overflow: "hidden",
                background: "#fff",
              }}
            >
              <Accordion
                expanded={expanded === question.questionId}
                // onChange={handleAccordionChange(question.questionId)}
                sx={{
                  "&:before": { display: "none" },
                  boxShadow: "none",
                }}
              >
                <AccordionSummary
                  sx={{
                    backgroundColor: "#ffffff",
                    p:{xs:'2px 8px 2px 8px', sm:2, md:2} ,
                    "& .MuiAccordionSummary-content": {
                      display: "flex",
                      flexDirection:{xs:'row', sm:'row', md:'row'},
                      alignItems: "center",
                      justifyContent: {xs:'flex-start', sm:'flex-start', md:'flex-start'},
                      flexWrap: "wrap",
                      gap: { xs: 1, sm: 2, md: 3 },
                      minWidth: 0,
                    },
                  }}
                >

                  <Box sx={{ // index + 1
                    display: "flex", alignItems: "center", width: 25, height:28, justifyContent: "center", gap: 0.5,
                    backgroundColor: "#E9EFFD",borderRadius:{xs:'4px', sm:'4px', md:'4px'},alignSelf:'baseline',
                    // color: question?.response_recorded === "correct" ? "#2e7d32" : question?.response_recorded === null ? "#757575" : "#d32f2f",
                    p:1.2, fontSize: { xs: 10 , sm: 13 , md: 13}, fontWeight: 600, textTransform: "capitalize",
                  }} >
                    {index + 1}
                  </Box>
                  <Box sx={{display:'flex', flexDirection:{xs:'column', sm:'column', md:'row'},  flex: 1, justifyContent: {xs:'flex-start', sm:'flex-start', md:'space-around'},alignItems: {md:'baseline'}, gap:{ xs: 2 , sm: 2 , md: 5 } }}>
                  <Box sx={{ // Correct , Not Answered , Incorrect
                    display: "flex", alignItems: "center", width:{ xs : 100 , sm : 130 , md : 130 }, height:30,justifyContent: "center", gap: 0.5,
                    backgroundColor: question?.response_recorded === "correct" ? "#e8f5e9" : question?.response_recorded === null ? "#e3e8ef" : "#ffebee",
                    color: question?.response_recorded === "correct" ? "#2e7d32" : question?.response_recorded === null ? "#3F3F3F" : "#d32f2f",
                    px: 1.2, py: 3, borderRadius: {xs:'4px', sm:'4px', md:'4px'}, fontSize:{xs:9, sm:14, md:14}, fontWeight: 600, textTransform: "capitalize",
                  }} >
                     {question?.response_recorded === "correct"
                      ? "Correct"
                      : question?.response_recorded === null
                        ? "Not Answered"
                        : "Incorrect"}
                    {question?.response_recorded === "correct" ? (
                      <DoneIcon sx={{ml: 1, fontSize: 16 }} />
                    ) : question?.response_recorded === null ? (
                      <Typography sx={{ml: 1, fontSize: 18 , color:'#3F3F3F'}}>!</Typography>
                    ) : (
                      <CloseIcon sx={{ml: 1, fontSize: 16 }} />
                    )}
                   
                  </Box>

                    <Box id='123' sx={{ // 3 typography
                      display: "flex",
                      flexDirection: { xs: "row", sm: "row", md: "row" },
                      justifyContent: { xs: "flex-start", sm: "flex-start", md: "flex-start" },
                      alignItems: "center",
                      columnGap: { xs: 2, sm: 4, md: 6 },
                      rowGap: 1,
                      flex: 1,
                      minWidth: 0,
                      flexWrap: "wrap",
                    }}>
                  <Typography variant="body2" sx={{ fontWeight: 600, color: 'black' , fontSize:{ xs: 9 , sm: 16 , md: 14} }}> {/* Time spent:  */}
                    Time spent: {
                      (
                        question?.timeTaken > 1000000
                          ? (question.timeTaken / 1000000000).toFixed(2) 
                          : question?.timeTaken?.toFixed(2)
                      )
                    }s
                  </Typography>


                  <Typography variant="body2" sx={{ fontWeight: 600, color: 'black' , fontSize:{ xs: 9 , sm: 16 , md: 14} }}> {/* Selected option: */}
                    Selected option:{" "}
                    <Box component="span" sx={{ fontWeight: 600, color: 'inherit' }}>
                      {(() => {
                        const parsedAnswer =
                          typeof question.options  === "string"
                            ? JSON.parse(question.options )
                            : question.options ;

                        const options = parsedAnswer?.mcqOptions || [];
                        const selectedIndex = options.findIndex(
                          (opt) => opt.trim() === question.selectedAnswer?.trim()
                        );
                        const selectedLabel =
                          selectedIndex !== -1 ? String.fromCharCode(65 + selectedIndex) : "";

                        return (
                          <>
                            {selectedLabel ? `${selectedLabel} ` : '-'}

                          </>
                        );
                      })()}
                    </Box>
                  </Typography>
                  <Typography variant="body2" sx={{ fontWeight: 600, color: 'black' , fontSize:{ xs: 9 , sm: 16 , md: 14} }}> {/* correct answer */}
                    Correct answers:{" "}
                    <Box component="span" sx={{ fontWeight: 600, color: 'inherit'}}>
                      {(() => {
                        const parsedAnswer =
                          typeof question.options  === "string"
                            ? JSON.parse(question.options )
                            : question.options ;

                        const options = parsedAnswer?.mcqOptions || [];
                        const correctAnswers = parsedAnswer?.correctAnswer || [];
                        const correctIndex = correctAnswers.findIndex((ans) => ans === true);
                        const correctLabel =
                          correctIndex !== -1 ? String.fromCharCode(65 + correctIndex) : "";

                        return (
                          <>
                            {correctLabel && `${correctLabel} `}
                          </>
                        );
                      })()}
                    </Box>
                  </Typography>
                  </Box>

                  <Button //  View Question and Explanation
                    size="small"
                    sx={{
                      color: "#000000ff",
                      textTransform: "none",
                      fontWeight: 500,
                      fontSize:{xs:9, sm:14, md:14} ,
                      borderRadius: {xs:'4px', sm:'4px', md:'4px'},
                      background: '#eee',
                      '&:hover': { background: '#eee' },
                      width: { xs: '100%', sm: 'auto' },
                      maxWidth: { xs: 180, sm: 280, md: 'unset' },
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      ml: { xs: 0, sm: 0},
                      mt: { xs: 0, sm: 0 },
                      order: { xs: 2, sm: 0 },         
                      alignSelf: { xs: 'flex-start', sm: 'flex-start' },
                      pl:{ xs: 0.5 , sm: 3 , md: 3},
                      pr:{ xs: 0.5 , sm: 3 , md: 3}
                    }}
                    endIcon={<ExpandMoreIcon sx={{ fontSize: 30 }} />}
                    onClick={() => setExpanded(expanded === question.questionId ? null : question.questionId)}
                  >
                    {expanded === question.questionId
                      ? "Hide Question and Explanation"
                      : "View Question and Explanation"}
                  </Button>
                  </Box>
                </AccordionSummary>

                
                <AccordionDetails
                 sx={{
                    backgroundColor: expanded === question.questionId ? '#eee' : '#fff',
                    p:{xs:1.5, sm:3 ,md:3},
                    border:{xs:'8px solid #fff' , sm: '20px solid #fff' , md: '20px solid #fff'},
                    borderRadius:{ xs: 2 , sm: 3.5 , md: 4}
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: question?.passage
                        ? { xs: 'column', md: 'column' }
                        : { xs: 'column', md: 'row' },
                      alignItems: 'flex-start',
                      gap: 2,
                      width: '100%',
                    }}
                  >
                    <Box
                      sx={{
                        flex: 1,
                        display: 'flex',
                        flexDirection: question?.passage ? {xs:'column',sm:'column',md:'row'} : {xs:'column',sm:'column',md:'column'},
                        pr: !question?.passage ? { md: 2 } : 0,
                        minWidth: 0,
                      }}
                    >
                      {
                      question?.passage && (
                        <>
                          <Box sx={{ flex: 1 }}>
                            <Typography
                              variant="body1"
                              sx={{ fontWeight: 600, mb: 1, color: '#000' }}
                            >
                              PASSAGE:
                            </Typography>
                            <Typography
                              dangerouslySetInnerHTML={{ __html: question?.passage }}
                              variant="body2"
                              sx={{ lineHeight: 1.7, color: '#555', fontSize:{xs:12 , sm: 14 , md: 14} }}
                            />
                          </Box>

                          <Divider orientation="vertical" flexItem sx={{ borderColor: '#ccc', display: { xs: 'none', md: 'block' }, mx: 1, }} />
                        </>
                       )}

                      <Divider orientation="horizontal" sx={{
                        borderColor: '#ddd',
                        display: question?.passage ? { xs: 'block', md: 'none' } : { xs: 'none', md: 'none' },
                        my: 2,
                      }} />

                      <Box
                        sx={{
                          flex: !question?.passage ? 1 : 'unset',
                          width: question?.passage ? {xs:'100%', sm:'100%', md:'50%'} :{ xs:'100%', sm:'100%', md:'100%'},
                          pr: !question?.passage ? { md: 2 } : 0,
                          minWidth: 0,
                          ml:{xs:0 , sm:0 , md:1 }
                        }}
                      >
                        <Typography
                          variant="body1"
                          sx={{ mb: 1, mt:1, fontWeight: 600, color: '#000' }}
                        >
                          QUESTION:
                        </Typography>

                        <Typography
                          variant="body2"
                          sx={{ mb: 3, lineHeight: 1.7, color: '#333', fontSize:{xs:12 , sm: 14 , md: 14} }}
                          dangerouslySetInnerHTML={{ __html: question?.question_text }}
                        />

                        <Grid container spacing={1.5} sx={{ mb: 3, flexDirection: 'column' }}>
                          {(() => {
                            const parsedAnswer =
                              typeof question.options  === 'string'
                                ? JSON.parse(question.options )
                                : question.options ;
                            const options = parsedAnswer?.mcqOptions || [];
                            const correctAnswers = parsedAnswer?.correctAnswer || [];

                            return options.map((value, index) => {
                              const key = String.fromCharCode(65 + index);
                              const isCorrect = correctAnswers[index] === true;
                              const isSelected = question.selectedAnswer === value;
                              const isWrong = isSelected && !isCorrect;

                              return (
                                <Grid item xs={12} key={key}>
                                  <Box
                                    sx={{
                                      borderRadius: '8px',
                                      border: isWrong
                                        ? '1.8px solid #d32f2f'
                                        : isCorrect
                                          ? '1.8px solid #2e7d32'
                                          : '1px solid #000',
                                      p: 1.8,
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'space-between',
                                      backgroundColor: isCorrect
                                        ? '#e8f5e9'
                                        : isWrong
                                          ? '#ffebee'
                                          : '#eee',
                                      color: isCorrect
                                        ? '#000'
                                        : isWrong
                                          ? '#000'
                                          : '#000',
                                      transition: 'all 0.2s ease',
                                    }}
                                  >
                                    <Typography
                                      variant="body2"
                                      sx={{
                                        p: 1,
                                        fontWeight: 500,
                                        display: 'flex',
                                        alignItems: 'center',
                                        fontSize:{xs:10 , sm: 14 , md: 14}
                                      }}
                                    >
                                      <Box sx={{
                                        width: {xs:20,sm:24,md:28}, height: {xs:20,sm:24,md:28}, minWidth: {xs:20,sm:24,md:28}, minHeight: {xs:20,sm:24,md:28}, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 500, fontSize: {xs:10,sm:14,md:14}, borderRadius: '50%',
                                        border: isCorrect ? '2px solid #249935' : isWrong ? '2px solid #B50000' : '1px solid #000',
                                        backgroundColor: isCorrect ? '#249935' : isWrong ? '#B50000' : '#F4F4F4',
                                        color: isCorrect ? '#fff' : isWrong ? '#fff' : '#000', transition: 'all 0.2s', marginRight: 1.5, mb: '2px'
                                      }} > 
                                        {key} 
                                      </Box>

                                      <span dangerouslySetInnerHTML={{ __html: value }} />
                                    </Typography>

                                    {isCorrect && (
                                      <DoneIcon
                                        sx={{ color: '#2e7d32', marginRight: '10px' }}
                                      />
                                    )}
                                    {isWrong && (
                                      <CloseIcon sx={{ color: '#d32f2f', marginRight: '10px' }} />
                                    )}
                                  </Box>
                                </Grid>
                              );
                            });
                          })()}
                        </Grid>
                      </Box>
                    </Box>

                    <Divider sx={{ borderBottomWidth: 'thin', borderColor: '#ccc', marginTop: '0px', marginBottom: '14px', }} orientation="horizontal" flexItem />

                    {!question?.passage && (
                      <Divider orientation="vertical" flexItem sx={{ display: { xs: 'none', md: 'block' }, borderColor: '#e0e0e0', mx: 0, my: 0, }} />
                    )}

                  {/* Explanation Section */}
                    <Box
                      sx={{
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        pl: !question?.passage ? { md: 2 } : 0,
                        minWidth: 0,
                      }}
                    >
                      <Typography
                        variant="body1"
                        sx={{ fontWeight: 600, mb: 1, color: '#143681' }}
                      >
                        EXPLANATION:
                      </Typography>

                      <Typography
                        variant="body2"
                        sx={{ lineHeight: 1.7, color: '#555',  fontSize:{xs:12 , sm: 14 , md: 14} }}
                        dangerouslySetInnerHTML={{ __html: question?.justification }}
                      />
                    </Box>
                  </Box>
                </AccordionDetails>
              


              </Accordion>
            </Card>
          ))}
        </Box>
      </>
    );
  };



  // eslint-disable-next-line arrow-body-style
  const ViewReportPage = () => {
    return (
      <>
        <Box sx={{ mb: 3 }}>

          <Breadcrumbs
            aria-label="breadcrumb"
            sx={{
              padding: '15px',
              paddingLeft: '0px',
              paddingBottom: '15px',
              paddingTop: '14px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              fontWeight: '500'
            }}
            separator=">"
          >

            <Typography style={{
              cursor: 'pointer',
              textDecoration: 'none',
              border: 'none',
              background: 'none',
              fontSize: {xs:15 , sm:15 , md:16},
              fontWeight: '500'
            }}
              onClick={handleNavigation}
            >
              SAT Test Prep
            </Typography>

            <Typography style={{ fontWeight: '500', cursor:'pointer' }} onClick={handleNavigateOverview}> 
   
                <Typography variant="body2" style={{ fontWeight: '500' }}>
                  {
                    location.state?.data?.assessment_type_id === 'English Chapter Test' || location.state?.data?.assessment_type === 'Maths Chapter Test'
                      ? "SAT Subject Test"
                      : (
                       location.state?.data?.data?.assessment_type === 'English Chapter Test'
                          ? "Reading and Writing Chapter Test"
                          : location.state?.data?.data?.assessment_type === 'Maths Chapter Test' 
                            ? "Math Chapter Test"
                            : "SAT Chapter Test"
                      )
                  }
                </Typography>
              
            </Typography>
            <Typography variant="body2" style={{ fontWeight: '500', color: '#7A7A7A !important', cursor: 'pointer' }} onClick={handleNavigateAttempts} >{"Attempts"}</Typography> :
            <Typography variant="body2" style={{ fontWeight: '600', color: '#2563eb',  cursor:'default' }}>{"Test Report"}</Typography> :

          </Breadcrumbs>

          <Typography variant="h4" sx={{ mb: 0, mt: 2, fontWeight: 700, fontSize: {xs:'18px',sm:'32px',md:'32px'} }}>Your Practice Score Report</Typography>
          {/* {location.state.data?.type !== "Chapter" &&  */}
          <ScoreCard />
          {/* } */}
        </Box>

        <Box sx={{ mt: 2, mb: 2 }}>
          <Box item xs={12} md={6}>
            <QuestionWiseAnalysis />
          </Box>
        </Box>
      </>
    );
  };



  const getButtonStyle = (tab) => {
    const baseStyle = {
      borderRadius: '4px',
      px: 3,
      py: 1,
      fontWeight: 600,
      textTransform: 'none',
      border: 'none'
      //   transition: 'all 0.3s ease',
    };

    if (activeTab === tab) {
      return {
        ...baseStyle,
        background: 'linear-gradient(45deg, #1f4ed8 30%, #3b82f6 90%)',
        color: '#fff',
        boxShadow: '0 4px 20px rgba(31, 78, 216, 0.4)',
        border: '2px solid #1f4ed8',
        '&:hover': {
          background: 'linear-gradient(45deg, #1e40af 30%, #2563eb 90%)',
          boxShadow: '0 6px 25px rgba(31, 78, 216, 0.5)',
        }
      };
    }

    return {
      ...baseStyle,
      backgroundColor: '#fff',
      color: '#1f4ed8',
      border: '2px solid #e5e7eb',
      '&:hover': {
        backgroundColor: '#f8fafc',
        border: '2px solid #1f4ed8',
        transform: 'translateY(-1px)',
        boxShadow: '0 2px 10px rgba(31, 78, 216, 0.2)',
      }
    };
  };


  return (
    <Box sx={{ p: { xs: 2, md: 6 }, bgcolor: '#f8fafc', minHeight: '100vh' }}>
      <Box sx={{ maxWidth: 1560, mx: 'auto', margin: { xs: 'auto 30px',sm: 'auto 30px', md: 'auto 60px', lg: 'auto 60px', xl: 'auto' } }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
          <ButtonGroup variant="outlined" sx={{ background: '#fff', visibility:'hidden', padding: '14px 70px', borderRadius: '8px', border: '1px solid #ddd' }} aria-label="Report view options">
            <Button sx={{
              ...getButtonStyle('report'), border: 'none',
              '&:hover': { border: 'none' },
            }}
            // onClick={() => handleTabChange('report')}
            >
              View Report
            </Button>

            {location.state?.data?.assessment_type !== "SatFullTest" && location.state?.data?.data?.type !== "Chapter" &&
              <Button
              
                sx={{
                  ...getButtonStyle('solution'), border: 'none',
                  '&:hover': { border: 'none' },
                }}
              // onClick={() => handleTabChange('solution')}
              >
                View Solution
              </Button>}
          </ButtonGroup>
        </Box>

        {activeTab === 'report' && <ViewReportPage />}
      </Box>
    </Box>
  );
}


export default SATReportReplica;